import { Component, HostBinding, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../..//field.interface";
@Component({
  selector: "app-radiobutton",
  template: `
        <div class="row m-1">
        <label class="radio-label-padding">{{field.label}}:</label>
          <div class="col-12 demo-full-width margin-top" [formGroup]="group">
            <mat-radio-group [formControlName]="field.name">
              <mat-radio-button class="m-1" *ngFor="let item of field.options" [value]="item" [disabled]="field.disabled">{{item}}</mat-radio-button>
            </mat-radio-group>
          </div>
      </div>

`,
  styles: []
})
export class RadiobuttonComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
  }
}
